"use client";
import { useEffect } from 'react';
import FallbackComponent from '@/components/common/FallbackComponent/FallbackComponent';

export default function NotFound() {
  useEffect(() => {
    // Set a custom attribute on the document
    document.documentElement.setAttribute('data-not-found', 'true'); 
    return () => {
      // Clean up when component unmounts
      document.documentElement.removeAttribute('data-not-found');
    };
  }, []);

  return <FallbackComponent/>;
}